import { render, staticRenderFns } from "./dr-layout-placeholder.vue?vue&type=template&id=6435721d"
import script from "./dr-layout-placeholder.vue?vue&type=script&lang=js"
export * from "./dr-layout-placeholder.vue?vue&type=script&lang=js"
import style0 from "./dr-layout-placeholder.vue?vue&type=style&index=0&id=6435721d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../player/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports